import type React from 'react';

export const sectionStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: 12,
    borderRadius: 8,
    border: '1px solid #3f3f46',
    background: '#0e0e11',
    textAlign: 'left',
};

export const labelStyle: React.CSSProperties = {
    fontSize: 12,
    fontWeight: 650,
    color: '#d4d4d8',
};

export const rowStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
};

export const inputStyle: React.CSSProperties = {
    flex: 1,
    minWidth: 0,
    boxSizing: 'border-box',
    padding: 10,
    borderRadius: 8,
    border: '1px solid #3f3f46',
    background: '#16161a',
    color: '#e4e4e7',
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    fontSize: 12,
};

export const buttonStyle: React.CSSProperties = {
    cursor: 'pointer',
    border: '1px solid #3f3f46',
    background: 'transparent',
    color: '#e4e4e7',
    borderRadius: 6,
    padding: '8px 14px',
    fontSize: 13,
    fontWeight: 600,
};

export const applyButtonStyle: React.CSSProperties = {
    ...buttonStyle,
    background: '#2563eb',
    borderColor: '#2563eb',
    color: '#fff',
};

export const hintStyle: React.CSSProperties = {
    margin: 0,
    fontSize: 12,
    color: '#a1a1aa',
};

export const errorStyle: React.CSSProperties = {
    margin: 0,
    fontSize: 12,
    color: '#fca5a5',
};
